import _ from "lodash";
import numeral from "numeral";
import { useEffect, useMemo } from "react";
import { useBalanceStore } from "../../../_store/balanceStore";
import { useInvestStore } from "../../../_store/investStore";
import { DonutChartInvestMain } from "../../../components/chart/DonutChartMain";
import { cn } from "../../../utils/useFunctions";
import { key_property_invest_category } from "../../balance/functions";
import { PdfCard, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_NORMAL_11,
} from "../styles/pdf.style";
import {
  RandomDarkGreenColorHSL,
  RandomGreenColorHSL,
  RandomOrangeColorHSL,
  RandomRedColorHSL,
} from "../../../functions/pdfGenerateFunction/colorGeneratingFunction";

// Function to generate random green-themed colors
const RandomGreenColor = () => {
  const greenPalette = [
    "#2D5016", // Dark forest green
    "#355E3B", // Hunter green
    "#4F7942", // Fern green
    "#228B22", // Forest green
    "#32CD32", // Lime green
    "#00FF32", // Electric green
    "#90EE90", // Light green
    "#98FB98", // Pale green
    "#00FA9A", // Medium spring green
    "#00FF7F", // Spring green
    "#3CB371", // Medium sea green
    "#2E8B57", // Sea green
    "#006400", // Dark green
    "#008000", // Green
    "#9ACD32", // Yellow green
    "#ADFF2F", // Green yellow
    "#7CFC00", // Lawn green
    "#7FFF00", // Chartreuse
    "#66CDAA", // Medium aquamarine
    "#20B2AA", // Light sea green
    "#00CED1", // Dark turquoise
    "#48D1CC", // Medium turquoise
    "#40E0D0", // Turquoise
    "#00FFFF", // Aqua
    "#E0FFFF", // Light cyan
  ];

  return greenPalette[Math.floor(Math.random() * greenPalette.length)];
};

// Alternative HSL-based green random color generator

// Function to generate unique random green colors
const getUniqueRandomGreenColor = (usedColors) => {
  let color;
  let attempts = 0;
  do {
    color = RandomGreenColorHSL();
    attempts++;
    if (attempts > 50) {
      // Fallback to palette method if HSL fails
      color = RandomGreenColor();
      break;
    }
  } while (usedColors.has(color));
  usedColors.add(color);
  return color;
};

const itemKey = {
  เงินฝาก: "#FFD200",
  ตราสารหนี้: "#B2C465",
  ตราสารทุน: "#EEA73C",
  ตราสารหนี้เอกชน: "#DFCE4C",
  สินทรัพย์ทางเลือก: "#EC723E",
};

function PdfPageInvestTwo({ page, itemInvestTwo, indexOutside, keyInvest }) {
  const balanceData = useBalanceStore((state) => state?.balanceData);
  const setBalanceData = useBalanceStore((state) => state?.setBalanceData);

  const usedColors = new Set();

  const getUniqueRandomColor = (usedColors, category) => {
    let color;
    let LIMIT = 99;
    let attempts = 0;

    color = RandomRedColorHSL(); // default fallback

    do {
      if (category === "property_invest_bond") {
        // console.log("green")
        color = RandomGreenColorHSL();
      }
      if (category === "property_other") {
        // console.log("orange")
        color = RandomOrangeColorHSL();
      }

      if (category === "property_debt_instruments") {
        color = RandomRedColorHSL();
      }

      if (category === "property_money_market") {
        color = RandomDarkGreenColorHSL();
      }

      attempts++;

      // console.log("--------------");
    } while (usedColors.has(color) && attempts < LIMIT);
    usedColors.add(color);
    return color;
  };

  const getDetailField = balanceData?.property_invest_list
    ?.map((item) =>
      Object.entries(item)
        ?.map((item) => item[0])
        ?.filter(
          (item) =>
            ![
              "created",
              "color",
              "options_property_invest",
              "options_property_invest_title",
              "options_property_invest_category",
            ].includes(item)
        )
    )
    ?.flat();

  const tempPropertyInvestList = balanceData?.property_invest_list?.map(
    (itemMain, index) => {
      let tempFieldName = getDetailField[index];

      let tempitemMain = itemMain?.[tempFieldName]?.filter((item) => item);

      let tempColor = tempitemMain?.map((item) => {
        if (!itemKey[item?.label]) {
          return {
            ...item,
            color: getUniqueRandomColor(
              usedColors,
              itemMain.options_property_invest_category
            ),
          };
        }
        return { ...item, color: itemKey[item?.label] };
      });
      return { ...itemMain, [tempFieldName]: tempColor };
    }
  );

  const tempDebtInvest = balanceData?.debt_long_list
    ?.map(
      (item) =>
        item?.debt_long_others || item?.debt_long_places || item?.debt_long_cars
    )
    ?.flat()
    .filter((item) => item?.personal_or_investment === "investment");

  const totalDebtInvest = tempDebtInvest?.reduce((prev, curr) => {
    return prev + Number(curr?.current_price || 0);
  }, 0);

  const colorDebtLongLists = () => {
    let tempDebtLongLists = balanceData?.debt_long_list;
    let tempDebtLongListsOthers = balanceData?.debt_long_list?.find(
      (item) => item?.options_debt_long === "debt_long_other"
    )?.debt_long_others;
    let tempDebtLongListsCars = balanceData?.debt_long_list?.find(
      (item) => item?.options_debt_long === "debt_car"
    )?.debt_long_cars;
    let tempDebtLongListsPlaces = balanceData?.debt_long_list?.find(
      (item) => item?.options_debt_long === "debt_place"
    )?.debt_long_places;


    tempDebtLongListsOthers = tempDebtLongListsOthers?.map((item) => {
      if (item?.personal_or_investment === "investment") {
        return {
          ...item,
          color: getUniqueRandomColor(usedColors, "property_other"),
        };
      }
      return item;
    });

    tempDebtLongListsCars = tempDebtLongListsCars?.map((item) => {
      if (item?.personal_or_investment === "investment") {
        return {
          ...item,
          color: getUniqueRandomColor(usedColors, "property_other"),
        };
      }
      return item;
    });

    tempDebtLongListsPlaces = tempDebtLongListsPlaces?.map((item) => {
      if (item?.personal_or_investment === "investment") {
        return {
          ...item,
          color: getUniqueRandomColor(usedColors, "property_other"),
        };
      }
      return item;
    });

    return tempDebtLongLists?.map((item) => {
      if (item?.debt_long_others) {
        return {
          ...item,
          debt_long_others: tempDebtLongListsOthers,
        };
      }

      if (item?.debt_long_cars) {
        return {
          ...item,
          debt_long_cars: tempDebtLongListsCars,
        };
      }

      if (item?.debt_long_places) {
        return {
          ...item,
          debt_long_places: tempDebtLongListsPlaces,
        };
      }
    });
  };


  useEffect(() => {
    setBalanceData({
      ...balanceData,
      property_invest_list: tempPropertyInvestList,
      debt_long_list: [...colorDebtLongLists() || []],
    });
  }, []);

  return (
    <div key={indexOutside} className="flex flex-col space-y-2">
      <div className={cn(STYLE_PAGE)}>
        <PdfHeader />
        <PdfLine />
        <PdfHeaderText title="การจัดทัพการลงทุน" icon="/images/revenue.svg" />
        {/* การจัดทัพการลงทุน */}
        <PdfCard
          title={`สัดส่วนการลงทุน${itemInvestTwo?.label}`}
          className={"flex flex-col space-y-3"}
          classNameTitle="text-left"
        >
          <PdfCardWhite className={cn("flex space-x-2 justify-center")}>
            <DonutChartInvestMain
              classNameRoot={cn("flex")}
              className={cn("w-[140px] h-[140px] pt-0")}
              classNameDetail={cn("space-y-1")}
              classNameText={cn(STYLE_PDF_TEXT_NORMAL_11)}
              width={20}
              height={20}
              sectionFrom="PdfPageInvestTwo"
              items={itemInvestTwo?.items?.filter((item) => item?.value > 0)}
            />
          </PdfCardWhite>
        </PdfCard>
        <PdfCard>
          <PdfCardWhite className={cn("flex flex-col")}>
            <div className={cn("flex", STYLE_PDF_TEXT_MEDIUM_11)}>
              <div className={cn("w-[20%]")}>หัวข้อ</div>
              <div className={cn("w-[25%]")}>รายการ</div>
              <div className={cn("w-[20%]")}>มูลค่าปัจจุบัน</div>
              <div className={cn("w-[15%]")}>ผลตอบแทน (%)</div>
              <div className={cn("w-[20%] text-right")}>สัดส่วน</div>
            </div>
            <div className={cn("border border-b border-mainblue mt-1")}></div>
            <div className="mt-2 flex flex-col space-y-2">
              {itemInvestTwo?.items?.filter((item) => item?.value > 0)?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={cn("flex", STYLE_PDF_TEXT_MEDIUM_11)}
                  >
                    <div className={cn("w-[20%]")}>
                      {index === 0 && itemInvestTwo?.label}
                    </div>
                    <div className={cn("w-[25%]")}>{item?.label}</div>
                    <div className={cn("w-[20%]")}>
                      {numeral(item?.amount).format("0,0")}
                    </div>
                    <div className={cn("w-[15%]")}>
                      {numeral(item?.reward_amount_per_year).format("0.00")}
                    </div>
                    <div className={cn("w-[20%] text-right")}>
                      {numeral(item?.value).format("0.00")}%
                    </div>
                  </div>
                );
              })}
            </div>
          </PdfCardWhite>
        </PdfCard>
        <PdfFooter page={page} />
      </div>
    </div>
  );
}

export default PdfPageInvestTwo;
